/* eslint-disable jsx-a11y/anchor-is-valid */
import axios from 'axios'
import React, {useState} from 'react'
import {useIntl} from 'react-intl'
import {toAbsoluteUrl} from '../../../../../../_metronic/helpers'
import {Skeleton} from 'primereact/skeleton'

const API_URL = process.env.REACT_APP_API_URL || 'api'

type Props = {
  iconPath?: string
  iconColor?: string
  title: string
  subtitle1: string
  subtitle2: string
  total?: string
  total2?: string
  color?: string
}

const CardSystemWidgetContractCost: React.FC<Props> = ({
  title,
  subtitle2,
  subtitle1,
  color,
  total,
  total2,
}) => {
  const intl = useIntl()

  return (
    <div className='card text-left  mb-3 ms-3'>
      {/* begin::Body */}
      <div className='card-body d-flex align-items-center pt-3 pb-3'>
        <div className='d-flex flex-column flex-grow-1 '>
          <div className='text-center fw-bolder fs-6'> {title}</div>

          <span className='mt-2 mb-10 fs-5 mb-lg-4 fw-bold'>
            {total ? (
              <div className='row mt-3'>
                <div className='col-6 text-gray-500 text-center border-end-dashed  border-gray-300'>
                  <span className=''>
                    <p className='fs-4 text-primary text-center me-2 p-0 m-0 px-1 '>
                      {/* {total} */}
                      {total}
                    </p>
                  </span>
                  <div className='fs-8'>{subtitle1}</div>
                </div>

                <div className='col-6 text-gray-500 text-center'>
                  <span className=''>
                    <p className='fs-4 text-primary text-center me-2 p-0 m-0 px-1 '>
                      {/* {total} */}
                      {total2}
                      {/* <span className='badge badge-light-danger ms-2 fs-base'>
                        <i className='bi bi-arrow-down fs-8 text-danger ms-n1'></i>
                        2.2%
                      </span> */}
                    </p>
                  </span>
                  <div className='fs-8'>{subtitle2}</div>
                </div>
              </div>
            ) : (
              <>
                <Skeleton className='mb-2'></Skeleton>
                <Skeleton className='mb-2'></Skeleton>
              </>
            )}
          </span>
        </div>
      </div>
      {/* end::Body */}
    </div>
  )
}

export {CardSystemWidgetContractCost}
